export const getPlan = (plans, planId) => {
  for (let index = 0; index < plans.length; index++) {
    if (plans[index].id === planId) return plans[index];
  }
};

export const getSubId = (subs, planId) => {
  for (let index = 0; index < subs.length; index++) {
    if (subs[index].stripePlanId === planId) return subs[index].subscriptionId;
  }
};

export const trackAddedProduct = (subscriptionObj, subscriptionPlanId, trialEligible) => {
  if (window && window.analytics) {
    const plan = getPlan(subscriptionObj.availablePlans, subscriptionPlanId);
    window.analytics.track('Added Product', {
      id: plan.id,
      sku: plan.id,
      name: plan.name,
      price: plan.amount / 100,
      category: 'Subscription',
      interval: plan.interval,
      intervalCount: plan.intervalCount,
      trialEligible: trialEligible,
      currency: plan.currency,
      quantity: 1
    });
  }
};

export const trackCompletedOrder = (subscriptionObj, planId) => {
  if (window && window.analytics && window.analytics.track) {
    const subId = getSubId(subscriptionObj.subscriptions, planId);
    const plan = getPlan(subscriptionObj.availablePlans, planId);

    window.analytics.track('Completed Checkout Step', {
      step: 2
    });

    window.analytics.track('Completed Order', {
      orderId: subId,
      total: 0,
      // discount: '', TODO update once we have discount codes working
      // coupon: '', TODO update once we have coupon codes working
      currency: plan.currency,
      products: [
        {
          id: plan.id,
          sku: plan.id,
          name: plan.name,
          price: plan.amount / 100,
          quantity: 1,
          category: 'Subscription'
        }
      ]
    });
  }
};


export const trackFailedOrder = (error) => {
  if (error && window && window.analytics) {
    window.analytics.track('Failed Order', {
      code: error.code,
      reason: error.message
    });
  }
};
